import React, { ReactNode } from "react"
import { InfoBox, IconInfo, Help } from "dash-styled"

interface SimpleInfoBoxProps {
    variant: "plain" | "info" | "warning" | "alert"
    children: ReactNode
    className?: string
    helpText?: string
}

export const SimpleInfoBox = ({
    children,
    variant,
    className,
    helpText = ""
}: SimpleInfoBoxProps) => (
    <InfoBox variant={variant} className={className}>
        {helpText === "" ? (
            <IconInfo size="xl" />
        ) : (
            <Help text={helpText} tooltipPlacement="bottom" />
        )}
        {children}
    </InfoBox>
)
